import axios from 'axios';
import * as CONFIG from '../config/index';
export const FILE_API_URL = `${CONFIG.API_URL}/file`;

export const DOWNLOAD_FILE_API_URL = `${FILE_API_URL}/download`

export const removeFile = async (ids) => {
  const res = await axios.delete(`${FILE_API_URL}/deleteById?id=${ids}`)
  return res.data
}

export const getFileInfoList = async (ids) => {
  const res = await axios.get(`${FILE_API_URL}/get-fileinfo?fileIds=${ids}`)
  return res.data
}

export const downloadFile = async (id, fileName) => {
  axios.get(`${DOWNLOAD_FILE_API_URL}/${id}`, {
      responseType: 'blob'
    })
    .then(res => {
      const headers = res.headers;
      const blob = new Blob([res.data], {
        type: headers['content-type']
      })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      link.click()
    })
}

export const getImageInfos = async (list) => {
  if (!list) {
    return;
  }
  const files = await getFileInfoList(list)
  return (files && files.length > 0 && files.map(f => ({
    id: f.id,
    size: f.fileSize,
    name: f.fileName,
    type: f.mimeType,
    url: `${CONFIG.API_URL}/image/${f.id}`
  }))) || []
}



// WEBPACK FOOTER //
// ./src/common/file.js